import React from 'react';
import { UserForm } from './UserForm';
import { useParams, useNavigate } from 'react-router-dom';
import { useNotification } from '../../components/Notifications';

export function UserEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {addNotification} = useNotification();

  return (
    <UserForm
      isEditMode
      userId={Number(id)}
      onSuccess={() => {
        addNotification('User updated successfully!', 'success');
        navigate('/users');
      }}
    />
  );
};
